import { components } from 'react-select'

import { ICONS_NAME, IconV2 } from '../../../'

export const DropdownIndicator = (
    props,
) => (
    <components.DropdownIndicator {...props}>
        <IconV2
            name={ICONS_NAME.downArrow}
            color={
                props.isFocused
                    ? props.theme.colors.primary
                    : props.theme.colors.neutral20
            }
            size={12}
        />
    </components.DropdownIndicator>
)
